import create from 'zustand';
import { persist } from 'zustand/middleware';

interface PaywallState {
  hasSeenPaywall: boolean;
  paywallTimestamp: number | null;
  setHasSeenPaywall: (hasSeen: boolean) => void;
  clearPaywallState: () => void;
  checkAndResetPaywallIfExpired: () => boolean;
  getRemainingMinutes: () => number | null;
}

export const PAYWALL_TIMEOUT_MINUTES = 30;

export const usePaywallStore = create<PaywallState>()(
  persist(
    (set, get) => ({
      hasSeenPaywall: false,
      paywallTimestamp: null,
      
      setHasSeenPaywall: (hasSeen: boolean) => {
        const timestamp = hasSeen ? Date.now() : null;
        set({ 
          hasSeenPaywall: hasSeen,
          paywallTimestamp: timestamp
        });
      },
      
      clearPaywallState: () => {
        set({ 
          hasSeenPaywall: false,
          paywallTimestamp: null
        });
      },

      checkAndResetPaywallIfExpired: () => {
        const state = get();
        
        // If user hasn't seen paywall, return current state
        if (!state.hasSeenPaywall || !state.paywallTimestamp) {
          return state.hasSeenPaywall;
        }

        // Check if 30 minutes have passed since the timestamp
        const currentTime = Date.now();
        const timeDifferenceMinutes = (currentTime - state.paywallTimestamp) / (1000 * 60);
        
        if (timeDifferenceMinutes >= PAYWALL_TIMEOUT_MINUTES) {
          // Reset the paywall state if 30 minutes have passed
          set({ 
            hasSeenPaywall: false,
            paywallTimestamp: null
          });
          return false;
        }
        
        return state.hasSeenPaywall;
      },

      getRemainingMinutes: () => {
        const state = get();
        
        if (!state.hasSeenPaywall || !state.paywallTimestamp) {
          return null;
        }

        const currentTime = Date.now();
        const timeDifferenceMinutes = (currentTime - state.paywallTimestamp) / (1000 * 60);
        const remainingMinutes = PAYWALL_TIMEOUT_MINUTES - timeDifferenceMinutes;
        
        return remainingMinutes > 0 ? Math.ceil(remainingMinutes) : 0;
      },
    }),
    {
      name: 'paywall-storage',
    }
  )
); 